function IsDataNull(props: any) {
  return <div style={{ whiteSpace: "nowrap" }}>{props.data ? <>{props.data}</> : <>-</>}</div>;
}

export default IsDataNull;
